import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/loader";
import { adminPaths } from "../../../routes/admin";
import AdminLayout from "../../../layouts/AdminLayout";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../../components/form/NoRecord";
import TableHeader from "../../../components/table/tableHeader";
import ReactPagination from "../../../components/table/ReactPagination";
import PaginationDropdown from "../../../components/table/PaginationDropdown";
import WebinarDetails from "../../../components/pages/admin/modals/WebinarDetails";
import CreateWebinar from "../../../components/Modals/common/webinar/CreateWebinar";
import ConfirmationModal from "../../../components/Modals/common/webinar/ConfirmationModal";
import CreateBootCampStep1 from "../../../components/Modals/admin/bootcamp/CreateBootCampStep1";
import CreateBootCampStep3 from "../../../components/Modals/admin/bootcamp/CreateBootCampStep3";
import CreateBootCampStep2 from "../../../components/Modals/admin/bootcamp/CreateBootCampStep2";
import {
  clearBootCampFormData,
  curSym,
  pipViewDate,
  updateBootCampFormData,
} from "../../../utils/pip";
import {
  deleteBootcamp,
  deleteWebinar,
  deleteWorkshop,
  fetchBootcamps,
  getWebinarAllData,
  fetchBookingDetails,
  getAllWebinarAdminData,
  getAllWorkshopAdminData,
  fetchOffers,
  cloneBootcamp,
  fetchNuterra,
  deleteNuterra,
  toggleBootcampStatus,
  fetchWorkNuterraBookings,
  toggleNuterraStatus,
  toggleWorkShopStatus,
} from "../../../redux/features/admin/actions/authAction";
import OfferDetails from "../../../components/pages/find-a-job/modals/OfferDetails";
import WorkshopDetails from "../../../components/pages/admin/modals/WorkshopDetails";

const Events = () => {
  const editBootcampKey = "isEditBootcamp";
  const {
    isLoading,
    eventData,
    tabs,
    tableHeaders,
    bookingData,
    allWebinarList,
  } = useSelector((state) => state.admin.auth);
  const LocalKey = "event-page-tab";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [id, setId] = useState("");
  const [activeOffer, setActiveOffer] = useState(null);
  const [activeWorkshopBooking, setActiveWorkshopBooking] = useState(null);
  const [isWorkShopBookingModal, setIsWorkShopBookingModal] = useState(false);

  const [isOfferModal, setIsOfferModal] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isToggle, setIsToggle] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);
  const [step2DayData, setStep2DayData] = useState([]);
  const [activeCoach, setActiveCoach] = useState(null);
  const [isWebinar, setIsWebinar] = useState("webinar");
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem(LocalKey) || "all_webinar"
  );

  const [isWebCreateModal, setIsWebCreateModal] = useState(false);
  const [isCreateBootCamp, setIsCreateBootCamp] = useState(false);

  const [bootCampStep, setBootCampStep] = useState("0");
  const [isEdit, setIsEdit] = useState(false);

  const [bootcamp_id, setBootcamp_id] = useState();

  useEffect(() => {
    dispatch(fetchBootcamps());
    dispatch(getWebinarAllData());
    dispatch(fetchBookingDetails());
    dispatch(getAllWebinarAdminData());
    dispatch(getAllWorkshopAdminData());
    dispatch(fetchOffers());
    dispatch(fetchNuterra());
    dispatch(
      fetchWorkNuterraBookings({
        type: "nuterra",
      })
    );
    dispatch(
      fetchWorkNuterraBookings({
        type: "workshop",
      })
    );
  }, []);

  useEffect(() => {
    if (activeTab == tabs[7].value || activeTab == tabs[8].value)
      dispatch(
        fetchWorkNuterraBookings({
          type: activeTab == tabs[7].value ? "nuterra" : "workshop",
        })
      );
  }, [activeTab]);

  // 3️⃣ SET: Save to localStorage whenever activeTab changes
  useEffect(() => {
    localStorage.setItem(LocalKey, activeTab);
  }, [activeTab]);

  const paginatedList =
    eventData[activeTab]?.slice(
      currentPage * listPerPages,
      (currentPage + 1) * listPerPages
    ) || [];

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleDeleteBootcamp = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchBootcamps());
      }
    };
    dispatch(deleteBootcamp({ payload: id, callback }));
  };

  const handleDeleteNuterra = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchNuterra());
      }
    };
    dispatch(deleteNuterra({ payload: id, callback }));
  };

  const handleCloneBootcamp = (id) => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchBootcamps());
      }
    };
    dispatch(cloneBootcamp({ payload: id, callback }));
  };

  const handleToggleBootcampStatus = (id) => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchBootcamps());
      }
    };
    dispatch(toggleBootcampStatus({ id, callback }));
  };

  const handleToggleNuterraStatus = (id) => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchNuterra());
      }
    };
    dispatch(toggleNuterraStatus({ id, callback }));
  };

  const handleToggleWorkShopStatus = (id) => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(getAllWorkshopAdminData());
      }
    };
    dispatch(toggleWorkShopStatus({ id, callback }));
  };

  const tableBody = (item, index, paginatedList) => {
    switch (activeTab) {
      case tabs[0].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td>
                {item?.first_name ?? ""} {item?.last_name ?? ""}
              </td>
              <td>{pipViewDate(item?.created_at) ?? ""}</td>
              <td>{item?.phone_number ?? ""}</td>
              <td>{item?.role ?? ""}</td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          setActiveCoach(item);
                          setIsModal(true);
                        }}
                      >
                        View
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      case tabs[1].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td>
                <p className="ct_overlay_text">{item?.header_title ?? ""}</p>
              </td>
              <td>
                <p className="ct_overlay_text">
                  {item?.header_description ?? ""}
                </p>
              </td>
              <td>{pipViewDate(item?.created_at) ?? ""}</td>
              <td>{pipViewDate(item?.start_date) ?? ""}</td>
              <td>
                <div className="d-flex flex-column gap-2 position-relative">
                  <select
                    className="form-control ct_input border-0 ct_fit_content"
                    onChange={(e) => {
                      handleToggleBootcampStatus(item?.bootcamp_id);
                    }}
                    value={item?.status}
                  >
                    <option value={"Draft"}>Draft</option>
                    <option value={"Publish"}>Publish</option>
                  </select>
                  <i className="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                </div>
              </td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          navigate(adminPaths.BootcampDetail, {
                            state: {
                              id: item?.bootcamp_id,
                              data: paginatedList,
                            },
                          });
                        }}
                      >
                        View
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          handleCloneBootcamp(item?.bootcamp_id);
                        }}
                      >
                        Clone
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item ct_darksky_blue_text"
                        onClick={() => {
                          localStorage.setItem(editBootcampKey, true);
                          setIsCreateBootCamp(true);
                          setIsEdit(true);
                          setBootcamp_id(item?.bootcamp_id);
                          const data1 = {
                            header_title: item?.header_title || "",
                            start_date:
                              moment(item?.start_date).format("YYYY-MM-DD") ||
                              "",
                            end_date:
                              moment(item?.end_date).format("YYYY-MM-DD") || "",
                            location: item?.location || "",
                            header_description: item?.header_description || "",
                            header_sub_title: item?.header_sub_title || "",
                          };
                          // const cleanedProgramDays = (item?.program_days || [])?.map(
                          //   ({ program_day_id, sessions, ...dayRest }) => ({
                          //     ...dayRest,
                          //     sessions: (sessions || [])?.map(({ session_id, ...sessionRest }) => sessionRest),
                          //   })
                          // );

                          const cleanedProgramDays = (
                            item?.program_days || []
                          ).map(
                            ({
                              program_day_id,
                              sessions = [],
                              ...dayRest
                            }) => ({
                              ...dayRest,
                              sessions: sessions.map(
                                ({
                                  session_id,
                                  speakers = [],
                                  ...sessionRest
                                }) => ({
                                  ...sessionRest,
                                  speakers:
                                    speakers.length > 0
                                      ? speakers.map(
                                        ({
                                          session_speaker_id,
                                          name,
                                          role,
                                          image,
                                        }) => ({
                                          session_speaker_id:
                                            session_speaker_id || null,
                                          name: name || "",
                                          role: role || "",
                                          image: image || null,
                                        })
                                      )
                                      : [
                                        // {
                                        //   session_speaker_id: null,
                                        //   name: "",
                                        //   role: "",
                                        //   image: null,
                                        // },
                                      ],
                                })
                              ),
                            })
                          );
                          const data2 = {
                            bootCampData: {
                              bootcamp_price: item?.price || 0,
                              bootcamp_seat: item?.seats || "",
                            },
                            dayData: cleanedProgramDays,
                          };
                          const data3 = {
                            points: item?.points?.length
                              ? item.points.map((point) => ({ value: point }))
                              : [{ value: "" }],
                            footer_title: item?.footer_title || "",
                            footer_image: item?.footer_image || null,
                            footer_sub_title: item?.footer_sub_title || "",
                            footer_description: item?.footer_description || "",
                            header_image: item?.header_image || null,
                            brochure: item?.brochure || null,
                            brochure_color: item?.brochure_color ?? "#1e4457",
                            footer_color: item?.footer_color ?? "#023047",
                          };
                          updateBootCampFormData("step1", data1);
                          updateBootCampFormData("step2", data2);
                          updateBootCampFormData("step3", data3);
                          setBootCampStep("1");
                          // navigate(adminPaths.AddWebinar);
                        }}
                      >
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item text-danger"
                        onClick={() => setId(item?.bootcamp_id)}
                        data-bs-target="#ct_remove_bootcamp"
                        data-bs-toggle="modal"
                      >
                        Remove
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      case tabs[2].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td>
                <p className="ct_overlay_text">
                  {item?.first_name ?? ""} {item?.last_name ?? ""}
                </p>
              </td>
              <td>
                <p className="ct_overlay_text">{item?.email ?? ""} </p>
              </td>
              <td>
                <p className="ct_overlay_text">{item?.header_title ?? ""}</p>
              </td>
              <td>{pipViewDate(item?.start_date) ?? ""}</td>
              <td>{pipViewDate(item?.end_date) ?? ""}</td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          navigate(adminPaths.BootcampDetail, {
                            state: { id: item?.bootcamp_id },
                          });
                        }}
                      >
                        View
                      </a>
                    </li>
                    {/* <li>
                      <a
                        className="dropdown-item ct_darksky_blue_text"
                        // data-bs-target="#ct_edit_item_info"
                        // data-bs-toggle="modal"
                        onClick={() => {
                          navigate(adminPaths.UpdateWebinar);
                        }}
                      >
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item text-danger"
                        onClick={() => setId(item?.bootcamp_id)}
                        data-bs-target="#ct_remove_bootcamp"
                        data-bs-toggle="modal"
                      >
                        Remove
                      </a>
                    </li> */}
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      case tabs[3].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td>
                <p className="ct_overlay_text">
                  {item?.section_1?.title ?? ""}
                </p>
              </td>
              <td>{pipViewDate(item?.schedule_date) ?? ""}</td>
              <td>
                <p className="ct_overlay_text">
                  {item?.section_5?.cards
                    ? item?.section_5?.cards[0]?.text_2 || ""
                    : ""}
                </p>
              </td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          navigate(`${adminPaths.WebinarDetail}?webinar_id=${item?.webinar_id}`, {
                            state: { data: item },
                          });
                        }}
                      >
                        View
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item ct_darksky_blue_text"
                        onClick={() => {
                          navigate(adminPaths.UpdateWebinar, {
                            state: { data: item },
                          });
                        }}
                      >
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item text-danger"
                        onClick={() => setId(item?.webinar_id)}
                        data-bs-target="#ct_remove_webinar"
                        data-bs-toggle="modal"
                      >
                        Remove
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      case tabs[4].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td>
                <p className="ct_overlay_text">
                  {item?.section_1?.title ?? ""}
                </p>
              </td>
              <td>{pipViewDate(item?.schedule_date) ?? ""}</td>
              <td>
                <p className="ct_overlay_text">
                  {item?.section_4?.cards
                    ? item?.section_4?.cards[0]?.text_2 || ""
                    : ""}
                </p>
              </td>
              <td>
                <div className="d-flex flex-column gap-2 position-relative">
                  <select
                    className="form-control ct_input border-0 ct_fit_content"
                    onChange={(e) => {
                      handleToggleWorkShopStatus(item?.workshop_id);
                    }}
                    value={item?.status}
                  >
                    <option value={"Draft"}>Draft</option>
                    <option value={"Publish"}>Publish</option>
                  </select>
                  <i className="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                </div>
              </td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          navigate(`${adminPaths.WorkShopDetails}?.workshop_id=${item?.workshop_id}`, {
                            state: { data: item },
                          });
                        }}
                      >
                        View
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item ct_darksky_blue_text"
                        onClick={() => {
                          navigate(adminPaths.UpdateWorkshopData, {
                            state: { data: item },
                          });
                        }}
                      >
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item text-danger"
                        onClick={() => setId(item?.workshop_id)}
                        data-bs-target="#ct_remove_workshop"
                        data-bs-toggle="modal"
                      >
                        Remove
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      case tabs[5].value:
        return (
          <>
            {/* <tr>
              <td>{index + 1}</td>
              <td>
                <p className="ct_overlay_text">
                  {item?.section_1?.title ?? ""}
                </p>
              </td>
              <td>{pipViewDate(item?.schedule_date) ?? ""}</td>
              <td>
                <p className="ct_overlay_text">
                  {item?.section_4?.cards
                    ? item?.section_4?.cards[0]?.text_2 || ""
                    : ""}
                </p>
              </td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          navigate(adminPaths.WorkShopDetails, {
                            state: { data: item },
                          });
                        }}
                      >
                        View
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item ct_darksky_blue_text"
                        onClick={() => {
                          navigate(adminPaths.UpdateWorkshopData, {
                            state: { data: item },
                          });
                        }}
                      >
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item text-danger"
                        onClick={() => setId(item?.workshop_id)}
                        data-bs-target="#ct_remove_workshop"
                        data-bs-toggle="modal"
                      >
                        Remove
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr> */}

            <tr>
              <td>{index + 1}</td>
              <td className="text-capitalize">
                {item?.offer_title || "#N/A"}{" "}
              </td>
              <td>
                <span className="ct_pverlay_text d-inline-block">
                  {item?.purpose || "#N/A"}
                </span>
              </td>
              <td>{item?.offer_type || "#N/A"}</td>
              <td>{item?.duration || 0} minutes</td>
              <td className="text-capitalize">
                {" "}
                {item?.offer_format || "#N/A"}{" "}
              </td>
              <td>
                {curSym}
                {item?.price || 0}{" "}
              </td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          setActiveOffer(item);
                          setIsOfferModal(true);
                        }}
                      >
                        View
                      </a>
                    </li>
                    {/* <li>
                      <a
                        className="dropdown-item ct_darksky_blue_text"
                       
                      >
                        Edit
                      </a>
                    </li> */}
                    {/* <li>
                      <a
                        className="dropdown-item text-danger"
                        onClick={() => setId(item?.offer_id)}
                        data-bs-target="#ct_remove_offer"
                        data-bs-toggle="modal"
                      >
                        Remove
                      </a>
                    </li> */}
                  </ul>

                  {/* <i
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setActiveOffer(item);
                      setIsOfferModal(true);
                    }}
                    className="fa-solid fa-eye"
                  ></i> */}
                </div>
              </td>
            </tr>
          </>
        );
      case tabs[6].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td className="text-capitalize">
                {item?.section1?.heading || "#N/A"}{" "}
              </td>

              <td>{pipViewDate(item?.section1?.date) || "#N/A"}</td>
              <td>{item?.section1?.duration || 0}</td>
              <td>
                <div className="d-flex flex-column gap-2 position-relative">
                  <select
                    className="form-control ct_input border-0 ct_fit_content"
                    onChange={(e) => {
                      handleToggleNuterraStatus(item?.nuterra_id);
                    }}
                    value={item?.status}
                  >
                    <option value={"Draft"}>Draft</option>
                    <option value={"Publish"}>Publish</option>
                  </select>
                  <i className="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                </div>
              </td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          navigate(`${adminPaths.NuterraDetails}?nuterra_id=${item?.nuterra_id}`, {
                            state: { data: item },
                          });
                        }}
                      >
                        View
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          navigate(adminPaths.EditNuterraDetails, {
                            state: { data: item },
                          });
                        }}
                      >
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item text-danger"
                        onClick={() => setId(item?.nuterra_id)}
                        data-bs-target="#ct_remove_nuterra"
                        data-bs-toggle="modal"
                      >
                        Remove
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      case tabs[7].value:
      case tabs[8].value:
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              <td>
                <p className="ct_overlay_text">{item?.title ?? ""}</p>
              </td>
              <td>
                <p className="ct_overlay_text">{item?.name ?? ""}</p>
              </td>
              <td>{item?.email ?? ""}</td>
              <td>
                <div className="ct_right_dropdown dropdown">
                  <button
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-ellipsis"></i>
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          setActiveWorkshopBooking(item);
                          setIsWorkShopBookingModal(true);
                        }}
                      >
                        View
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </>
        );
      default:
        break;
    }
  };

  const renderCreateButton = () => {
    switch (activeTab) {
      case tabs[3].value:
        return (
          <button
            className="ct_yellow_btn ct_h_35 ct_w_100_575"
            onClick={() => {
              setIsWebCreateModal(true);
              setIsWebinar("webinar");
            }}
          >
            Create webinar
          </button>
        );
      case tabs[1].value:
        return (
          <button
            className="ct_yellow_btn ct_h_35 ct_w_100_575"
            onClick={() => {
              setIsCreateBootCamp(true);
              setBootCampStep("1");
            }}
          >
            Create bootcamp
          </button>
        );
      case tabs[4].value:
        return (
          <button
            className="ct_yellow_btn ct_h_35 ct_w_100_575"
            onClick={() => {
              setIsWebCreateModal(true);
              setIsWebinar("workshop");
            }}
          >
            Create workshop
          </button>
        );
      case tabs[6].value:
        return (
          <button
            className="ct_yellow_btn ct_h_35 ct_w_100_575"
            onClick={() => {
              navigate(adminPaths.CreateNuterra);
            }}
          >
            Create NuTerra
          </button>
        );

      default:
        break;
    }
  };

  const handleDeleteWebinar = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(getAllWebinarAdminData());
      }
    };
    dispatch(deleteWebinar({ payload: id, callback }));
  };

  const handleDeleteWorkshop = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(getAllWorkshopAdminData());
      }
    };
    dispatch(deleteWorkshop({ payload: id, callback }));
  };

  if (isLoading) {
    return <Loader />;
  };
  return (
    <>
      <AdminLayout>
        <div className="ct_px_40 mt-4">
          <div className="row">
            <div className="col-lg-3 col-md-3 mb-4 mb-md-0">
              <h4 className="mb-0 ct_fs_20 mb-4">Events</h4>
              <div className="ct_filter_btn">
                <button
                  className="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2"
                  onClick={() => {
                    setIsToggle(true);
                  }}
                >
                  Filter <img src="/assets/img/octicon_filter-16.png" alt="" />
                </button>
              </div>
              <div
                className={`ct_filter_sidebar ct_custom_scroll p-0 ${isToggle ? "show" : ""
                  }`}
              >
                <div
                  className="ct_close_filter d-block d-lg-none"
                  onClick={() => {
                    setIsToggle(false);
                  }}
                >
                  <i className="fa-solid fa-xmark"></i>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">Account Status</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Active
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Suspended
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Pending Approval
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Deactivated
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">Activity Level</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Last Active: Today
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Last 7 Days
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          30+ Days Inactive
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">User Plan</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Nuglow
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Nuforge
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Nustar
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Free
                        </label>
                      </div>
                    </li>
                    <li className="mt-2">
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Others
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="mt-4">
                  <h5 className="ct_fs_16 mb-3">Flagged</h5>
                  <ul>
                    <li>
                      <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label for="" className="ct_text_clr_757886">
                          Show Only Flagged Users
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-md-9 mb-4 mb-md-0">
              <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199 pb">
                <div>
                  <h4 className="mb-0 ct_fs_20 mb-0">Manage Content</h4>
                  <p className="mb-0 ct_text_clr_757886">
                    View, filter, and take action across all Nuvio user types
                  </p>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end  ct_flex_col_575">
                  <div className="position-relative ct_w_100_575">
                    <input
                      type="text"
                      className="form-control ct_input ct_h_35 ps-5"
                      placeholder="Search by Name"
                    />
                    <i className="fa-solid fa-search ct_input_icon_left"></i>
                  </div>
                  {renderCreateButton()}
                </div>
              </div>
              <div
                className="d-flex align-items-center gap-3 justify-content-between mb-3 ct_flex_col_575 ct_pb_3_575"
                style={{ borderBottom: "1px solid #cccccc" }}
              >
                <ul className="ct_table_filter ct_cursor_pointer">
                  <li
                    className={activeTab == "all_webinar" && "active"}
                    onClick={() => setActiveTab("all_webinar")}
                  >
                    Webinar ({eventData[tabs[3].value]?.length ?? 0})
                  </li>
                  <li
                    className={activeTab == "webinar" && "active"}
                    onClick={() => setActiveTab("webinar")}
                  >
                    Webinar Booking ({eventData[tabs[0].value]?.length ?? 0})
                  </li>
                  <li
                    className={activeTab == "work_shop" && "active"}
                    onClick={() => setActiveTab("work_shop")}
                  >
                    Workshop ({eventData[tabs[4].value]?.length ?? 0})
                  </li>
                  <li
                    className={activeTab == "workshop_bookings" && "active"}
                    onClick={() => {
                      setActiveTab("workshop_bookings");
                    }}
                  >
                    Workshop Booking({eventData[tabs[8]?.value]?.length || 0})
                  </li>
                  <li
                    className={activeTab == "bootcamp" && "active"}
                    onClick={() => setActiveTab("bootcamp") ?? 0}
                  >
                    Bootcamp ({eventData[tabs[1].value]?.length ?? 0})
                  </li>
                  <li
                    className={activeTab == "booking_list" && "active"}
                    onClick={() => setActiveTab("booking_list")}
                  >
                    Bootcamp Booking ({eventData[tabs[2].value]?.length ?? 0})
                  </li>
                  <li
                    className={activeTab == "offer_list" && "active"}
                    onClick={() => setActiveTab("offer_list")}
                  >
                    Offers ({eventData[tabs[5].value]?.length ?? 0})
                  </li>
                  <li
                    className={activeTab == "nuterra_list" && "active"}
                    onClick={() => setActiveTab("nuterra_list")}
                  >
                    NuTerra ({eventData[tabs[6].value]?.length || 0})
                  </li>
                  <li
                    className={activeTab == "nuterra_bookings" && "active"}
                    onClick={() => setActiveTab("nuterra_bookings")}
                  >
                    NuTerra Booking({eventData[tabs[7].value]?.length || 0})
                  </li>
                  <li>Registrants</li>
                  <li>Cross Group(1) </li>
                  <li>Coach Talks (1) </li>
                  <li>Masterclass (2) </li>
                </ul>
              </div>

              {/* Webinar Table S */}
              <div className={`d-block`}>
                <div className="table-responsive ct_custom_table ct_custom_table2 pt-2">
                  <table className="table">
                    <TableHeader data={tableHeaders[activeTab]} />
                    {paginatedList?.length > 0 && (
                      <tbody>
                        {paginatedList?.map((user, index) =>
                          tableBody(user, index, paginatedList)
                        )}
                      </tbody>
                    )}
                  </table>

                  {paginatedList?.length == 0 && <NoRecord />}
                </div>
                {paginatedList?.length != 0 && (
                  <div className="d-flex justify-content-between align-items-center mt-4 mb-4 ">
                    <div>
                      <PaginationDropdown
                        onChange={(val) => {
                          setListPerPages(val);
                          setCurrentPage(0);
                        }}
                      />
                    </div>
                    <div>
                      <ReactPagination
                        pageCount={Math.ceil(
                          eventData[activeTab]?.length / listPerPages
                        )}
                        onPageChange={handlePageClick}
                        currentPage={currentPage}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Bootcamp detail modal S --> */}
        <WebinarDetails
          isModal={isModal}
          setIsModal={setIsModal}
          data={activeCoach}
        />
        {isCreateBootCamp && bootCampStep == "1" ? (
          <CreateBootCampStep1
            onClose={() => {
              setIsCreateBootCamp(false);
              setBootCampStep("0");
              setIsEdit(false);
              clearBootCampFormData();
            }}
            onHanldeSubmit={() => {
              setBootCampStep("2");
            }}
            isEdit={isEdit}
          />
        ) : isCreateBootCamp && bootCampStep == "2" ? (
          <CreateBootCampStep2
            step2DayData={step2DayData}
            onClose={() => {
              setIsCreateBootCamp(false);
              setBootCampStep("0");
              setIsEdit(false);
              clearBootCampFormData();
            }}
            onHanldeSubmit={() => {
              setBootCampStep("3");
            }}
            setStep2DayData={setStep2DayData}
            previousForm={() => setBootCampStep("1")}
            isEdit={isEdit}
          />
        ) : (
          isCreateBootCamp &&
          bootCampStep == "3" && (
            <CreateBootCampStep3
              onClose={() => {
                setIsCreateBootCamp(false);
                setBootCampStep("0");
                setIsEdit(false);
                clearBootCampFormData();
              }}
              onHanldeSubmit={() => {
                setIsCreateBootCamp(false);
                setBootCampStep("0");
                setIsEdit(false);
                dispatch(fetchBootcamps());
              }}
              previousForm={() => setBootCampStep("2")}
              isEdit={isEdit}
              step2DayData={step2DayData}
              bootcamp_id={bootcamp_id}
            />
          )
        )}
        {isWebCreateModal && (
          <CreateWebinar
            setIsWebCreateModal={setIsWebCreateModal}
            isWebinar={isWebinar}
          />
        )}
        <ConfirmationModal
          id="ct_remove_user"
          title="Permanently Remove User"
        />
        <ConfirmationModal
          id="ct_remove_bootcamp"
          title="Delete Bootcamp"
          onConfirm={handleDeleteBootcamp}
        />
        <ConfirmationModal
          id="ct_remove_nuterra"
          title="Delete Nuterra"
          onConfirm={handleDeleteNuterra}
        />
        <ConfirmationModal
          id="ct_remove_webinar"
          title="Delete Webinar"
          onConfirm={handleDeleteWebinar}
        />
        <ConfirmationModal
          id="ct_remove_workshop"
          title="Delete Workshop"
          onConfirm={handleDeleteWorkshop}
        />

        <OfferDetails
          isModal={isOfferModal}
          setIsModal={setIsOfferModal}
          data={activeOffer}
        />

        <WorkshopDetails
          isModal={isWorkShopBookingModal}
          setIsModal={setIsWorkShopBookingModal}
          data={activeWorkshopBooking}
          modalname={activeTab == tabs[7]?.value ? "NuTerra" : "Workshop"}
        />
      </AdminLayout>
    </>
  );
};

export default Events;
